import { getRelativePath } from 'base/shared/Utils';
import { locale } from 'base/shared/Localization';
import { stringify } from 'qs';

export const SEO_LANDING_PATHS = {
  ABOUT_BADI: {
    ES: '/sobre-badi',
    EN: '/about-badi',
  },
};

export const getHomePath = ({ source = '' } = {}) => {
  const path = getRelativePath('/');

  return source ? `${path}?source=${encodeURI(source)}` : path;
};

export const getRegisterPath = () => {
  return getRelativePath('/register');
};

const BADI_PLUS_URL = {
  en: 'https://plus.badi.com',
  es: 'https://plus.badi.com/es',
};

export const getBadiPlusPath = (path = '/', { query } = {}) => {
  const baseUrl = BADI_PLUS_URL[locale() || 'en'];
  const queryString = query ? `?${stringify(query)}` : '';
  if (path.startsWith('/')) {
    return `${baseUrl}${path}${queryString}`;
  }
  return `${baseUrl}/${path}${queryString}`;
};

// Internal Badi Plus section (SPEC-0001). Same slug in every language, never with a trailing slash
// (the Android app captures badi.com URLs ending in "/").
export const BADI_PLUS_PATH = '/plus';

// Only the two URLs released with SPEC-0001 (/plus and /<lang>/plus); sub-landings must be added
// explicitly. Case-insensitive because react-router matches routes case-insensitively.
const BADI_PLUS_PATH_REGEXP = /^(\/[a-z]{2})?\/plus\/?$/i;

export const getBadiPlusHomePath = () => getRelativePath(BADI_PLUS_PATH);

export const isBadiPlusPath = (pathname) =>
  typeof pathname === 'string' && BADI_PLUS_PATH_REGEXP.test(pathname);

export const getAboutBadiPath = () =>
  getRelativePath(
    locale() === 'es' ? SEO_LANDING_PATHS.ABOUT_BADI.ES : SEO_LANDING_PATHS.ABOUT_BADI.EN
  );
